module.exports = __webpack_public_path__ + "img/logo_twitter_pb.59c0312e.svg";